module.exports = __webpack_public_path__ + "img/Balkon06.9e438278.jpg";